import { render, staticRenderFns } from "./InlineAdvice.vue?vue&type=template&id=6b9f1396&"
import script from "./InlineAdvice.vue?vue&type=script&lang=js&"
export * from "./InlineAdvice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports